import { refreshUserToken } from "../tools/refreshToken";

const originalFetch = window.fetch;

window.fetch = async (...args) => {
  try {
    const [url, options] = args;

    // Check if the request is uploading an image using FormData
    const isFormData = options?.body instanceof FormData;

    //if accessToken is no defined go to sign in

    if (window.location.pathname !== "/sign-in" && window.location.pathname !== "/sign-up" && !window.location.pathname.includes("verifyEmail")) {
      let token = localStorage.getItem("accessToken");
      console.log("token", token === "undefined");

      if (token === null || token === undefined || token === "" || token === "undefined") {
        console.log("No access token found, redirecting to sign in page");
        window.location.href = "/sign-in";
        return;
      }
    }

    const response = await originalFetch(...args);

    if (!response.ok && response.status === 400) {
      await refreshUserToken(args[0], window.fetch);
      //return response;
    }

    if (response.status === 401 && window.location.pathname !== "/sign-in") {
      console.log("Unauthorized access, redirecting to sign in page");

      console.log("Response status:", response);

      //window.location.href = "/sign-in";
    }

    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};
